import { faCheck, /*faCircleQuestion,*/ faSort, faChartArea } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-light-svg-icons'
import { Form } from "react-bootstrap";
import PropTypes from 'prop-types';
import './retakeResultsModal.scss'
import Modal from '../../../../../../../components/Modal/index'
import { useNavigate } from 'react-router-dom';

function RetakesModal(props) {
  const [showPoints, setShowPoints] = useState(true);
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-lastName');
  const [displayRetakeResults, setDisplayRetakeResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (props.assignmentResult) {
      let retakes = [{
        version: props.assignmentResult.retakeVersion,
        dateAssigned: props.assignmentResult.dateAssigned,
        dateStarted: props.assignmentResult.dateStarted,
        dateCompleted: props.assignmentResult.dateCompleted,
        correctCount: props.assignmentResult.correctCount,
        incorrectCount: props.assignmentResult.incorrectCount,
        crAnsweredCount: props.assignmentResult.crAnsweredCount,
        score: {
          points: props.assignmentResult.retriesAsNoCreditScore?.points ?? 0,
          percent: props.assignmentResult.retriesAsNoCreditScore?.percent ?? 0,
        }
      }];

      retakes = [...retakes, ...props.assignmentResult.retakeResults.map((retake) => {
        return {
          version: retake.retakeVersion,
          dateAssigned: retake.dateAssigned,
          dateStarted: retake.dateStarted,
          dateCompleted: retake.dateCompleted,
          correctCount: retake.correctCount,
          incorrectCount: retake.incorrectCount,
          crAnsweredCount: retake.crAnsweredCount,
          score: {
            points: retake.retriesAsNoCreditScore?.points ?? 0,
            percent: retake.retriesAsNoCreditScore?.percent ?? 0,
          }
        }
      })];

      setDisplayRetakeResults(retakes);
    }
  }, [props.assignmentResult])



  const handleAssignmentSort = (e) => {
    let sortedAssignmentResults = [...displayRetakeResults];

    if (e) sortByAscending.current = !sortByAscending.current;
    switch (sortResultsBy.current) {
      case 'sort-assignmentVersion':
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.version - b.version);
        break;
      case 'sort-dateAssigned':
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => (a.dateAssigned > b.dateAssigned) ? 1 : -1);
        break;
      case 'sort-dateStarted':
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => (a.dateStarted > b.dateStarted) ? 1 : -1);
        break;
      case 'sort-dateCompleted':
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.dateCompleted - b.dateCompleted);
        break;
      case 'sort-crAnsweredCount':
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.crAnsweredCount - b.crAnsweredCount);
        break;
      case 'sort-score':
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.score.points - b.score.points);
        } else {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.score.percent - b.score.percent);
        }
        break;
      default:
        sortedAssignmentResults = sortedAssignmentResults.sort((a, b) => a.version - b.version);
    }
    if (!sortByAscending.current) sortedAssignmentResults.reverse();

    setDisplayRetakeResults(sortedAssignmentResults);
  };


  return (
    <Modal
      contentWidth="70%"
      isOpen={props.show}
      titleName={<>Retake Results {/*<FontAwesomeIcon style={{ color: '#88CBF1', cursor: 'default' }} icon={faCircleQuestion} />*/}</>}
      onClose={props.onHide}>
      <div className="d-flex flex-column">
        <div className="header">
          <div><span>Student:</span><b>{` ${props.assignmentResult.studentFirstName} ${props.assignmentResult.studentLastName}`}</b></div>
          <div><span>Class:</span><b>{` ${props.assignmentResult.className}`}</b></div>
        </div>

        <div className="d-flex flex-row align-items-center justify-content-between mt-3">
          <div>
            <div style={{ fontSize: "14px", fontWeight: "500" }} className='text-color'>Show score as</div>
            <Form.Group id="scoreAsRetakeRadio" className="mx-3" >
              <Form.Check inline label="Points" name="retakeScoreGroup" type="radio" id="pointsRetakeRadio" defaultChecked="true" onChange={() => setShowPoints(true)} />
              <Form.Check inline label="Percent" name="retakeScoreGroup" type="radio" id="percenRetaketRadio" onChange={() => setShowPoints(false)} />
            </Form.Group>
          </div>
          <button className='reportButton' onClick={() => navigate('../reports/student_retake_report', {replace:true, state:{studentId: props.assignmentResult.studentId, selectedClassId: props.assignmentResult.classId}})}>
            <div className='icon'>
              <FontAwesomeIcon color="#82A9E2" icon={faChartArea} />
            </div>
            Student Retake Report
          </button>
        </div>
        <div className='custom-table my-3'>
          <table className='table'>
            <thead>
              <tr>
                <th>Assignment Version <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-assignmentVersion' icon={faSort} /></button></th>
                <th>Date Assigned <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-dateAssigned' icon={faSort} /></button></th>
                <th>Date Started <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-dateStarted' icon={faSort} /></button></th>
                <th>Date Completed <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-dateCompleted' icon={faSort} /></button></th>
                <th><FontAwesomeIcon icon={faCheck} /></th>
                <th><FontAwesomeIcon icon={faX} /></th>
                <th>CR Answered <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-crAnsweredCount' icon={faSort} /></button></th>
                <th>Score <button className='sort-btn' onClick={(e) => handleAssignmentSort(e)}><FontAwesomeIcon id='sort-score' icon={faSort} /></button></th>
              </tr>
            </thead>
            <tbody>
              {displayRetakeResults.length > 0 && displayRetakeResults.map((item, index) => {
                return (
                  <tr key={`assignmentResult_${index}`}>
                    <td>{item.version == 0 ? 'Original' : `Retake ${item.version}`}</td>
                    <td className='text-center'>{item.dateAssigned ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(item.dateAssigned)).replace(/\//g, '-') : ''}</td>
                    <td className='text-center'>{item.dateStarted ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(item.dateStarted)).replace(/\//g, '-') : ''}</td>
                    <td className='text-center'>{item.dateCompleted ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(item.dateCompleted)).replace(/\//g, '-') : ''}</td>
                    <td className='text-center'>{item.correctCount}</td>
                    <td className='text-center'>{item.incorrectCount}</td>
                    <td className='text-center'>{item.crAnsweredCount}</td>
                    <td className='text-center'>{showPoints ? item.score.points : `${item.score.percent} %`}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className='mb-2 mt-2 text-end fw-semibold'>
        Accumulated Retake Score : {showPoints ? props.retakeScore.points : props.retakeScore.percent + '%'}
        </div>
      </div>

    </Modal>
  );
}

RetakesModal.propTypes = {
  assignmentResult: PropTypes.any.isRequired,
  show: PropTypes.func,
  onHide: PropTypes.func,
  retakeScore:PropTypes.string
};


export default RetakesModal;